import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import API_URL from '../constants/environment';

const veifyOTP = async (email: string, otp: string) => {
    return axios.post<{ resetToken?: string }>(`${API_URL}/account/otp/verify`, { email, otp });
};

export const useVerifyOTP = () => {
    return useMutation({
        mutationFn: (data: { email: string, otp: string }) => veifyOTP(data.email, data.otp),
    });
}; 